import { IPrizeClassDescriptor } from '@/components/game/implementations/_default/_domain/models/prize-element';
import { Bingo90CallsData, Bingo90CatchUpData, Bingo90NextGameData, Bingo90ResetData } from '@/components/game/implementations/it/bingo-90/_domain/models';
import { BingoLiteCallsData, BingoLiteCatchUpData, BingoLiteNextGameData, BingoLiteResetData } from '@/components/game/implementations/it/bingo-lite/_domain/models';
import { SimboliCallsData, SimboliCatchUpData, SimboliNextGameData, SimboliResetData } from '@/components/game/implementations/it/simboli/_domain/models';
import { SmorfiaCallsData, SmorfiaCatchUpData, SmorfiaNextGameData, SmorfiaResetData } from '@/components/game/implementations/it/smorfia/_domain/models';
import { CincoCallsData, CincoCatchUpData, CincoNextGameData, CincoResetData } from '@/components/game/implementations/it/cinco/_domain/models';
import { Bingo75CallsData, Bingo75CatchUpData, Bingo75NextGameData, Bingo75ResetData } from '@/components/game/implementations/it/bingo-75/_domain/models';

class GamePrizeDescriptorsItaly {
  public getGamePrizeClasses(): { [key: string]: IPrizeClassDescriptor; } {
    return {
        bingo90: {
          callsDataClass: Bingo90CallsData,
          catchUpDataClass: Bingo90CatchUpData,
          nextGameDataClass: Bingo90NextGameData,
          resetDataClass: Bingo90ResetData
        },
        smorfia: {
          callsDataClass: SmorfiaCallsData,
          catchUpDataClass: SmorfiaCatchUpData,
          nextGameDataClass: SmorfiaNextGameData,
          resetDataClass: SmorfiaResetData
        },
        bingolite: {
          callsDataClass: BingoLiteCallsData,
          catchUpDataClass: BingoLiteCatchUpData,
          nextGameDataClass: BingoLiteNextGameData,
          resetDataClass: BingoLiteResetData
        },
        simboli: {
          callsDataClass: SimboliCallsData,
          catchUpDataClass: SimboliCatchUpData,
          nextGameDataClass: SimboliNextGameData,
          resetDataClass: SimboliResetData
        },
        cinco: {
          callsDataClass: CincoCallsData,
          catchUpDataClass: CincoCatchUpData,
          nextGameDataClass: CincoNextGameData,
          resetDataClass: CincoResetData
        },
        bingo75: {
          callsDataClass: Bingo75CallsData,
          catchUpDataClass: Bingo75CatchUpData,
          nextGameDataClass: Bingo75NextGameData,
          resetDataClass: Bingo75ResetData
        }
      };
  }
}

export { GamePrizeDescriptorsItaly };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/_factory/game-class-bindings-country-specific/game-class-bindings-it.ts